"use client";

import React from "react";
import Image from "next/image";
import { IconDeviceMobileMessage } from "@tabler/icons-react";
import { ModalBody, ModalContent, ModalHeader } from "@nextui-org/react";
import { CredientialLoginForm } from "./form/CredientialLoginForm";
import { CredientialSignUpForm } from "./form/CredientialLoginForm/SignUpForm";
import Link from "next/link";
import { Button, buttonVariants } from "@/03-presenters/components/ui/button";
import { create } from "zustand";
import { CredientialResetPwdForm } from "./form/CredientialLoginForm/ResetPwdForm";
import { cn } from "@/lib/utils";
export const useLoginType = create<{
  loginType: "login" | "register" | "reset";
  setLoginType: (loginType: "login" | "register" | "reset") => void;
}>(set => ({
  loginType: "login",
  setLoginType: (loginType: "login" | "register" | "reset") => set({
    loginType
  })
}));
function LoginHeader() {
  return <h2 className="text-xl font-bold text-neutral-800 dark:text-neutral-200" data-sentry-component="LoginHeader" data-sentry-source-file="LoginBody.tsx">
      登录账号
    </h2>;
}
function LoginBody() {
  const setLoginType = useLoginType(state => state.setLoginType);
  return <div data-sentry-component="LoginBody" data-sentry-source-file="LoginBody.tsx">
      <CredientialLoginForm data-sentry-element="CredientialLoginForm" data-sentry-source-file="LoginBody.tsx" />
      <div className="mt-4 flex justify-center text-sm">
        <span className="mr-2 text-gray-5">没有账号?</span>
        <span className="gradient-text cursor-pointer" onClick={() => setLoginType("register")}>
          注册
        </span>
      </div>
    </div>;
}
function SignUpHeader() {
  return <h2 className="text-xl font-bold text-neutral-800 dark:text-neutral-200" data-sentry-component="SignUpHeader" data-sentry-source-file="LoginBody.tsx">
      注册账号
    </h2>;
}
function SignUpBody() {
  const setLoginType = useLoginType(state => state.setLoginType);
  return <div data-sentry-component="SignUpBody" data-sentry-source-file="LoginBody.tsx">
      <CredientialSignUpForm data-sentry-element="CredientialSignUpForm" data-sentry-source-file="LoginBody.tsx" />
      <div className="mt-4 flex justify-center text-sm">
        <span className="mr-2 text-gray-5">已有账号</span>
        <span className="gradient-text cursor-pointer" onClick={() => setLoginType("login")}>
          登录
        </span>
      </div>
    </div>;
}
function ResetHeader() {
  return <h2 className="text-xl font-bold text-neutral-800 dark:text-neutral-200" data-sentry-component="ResetHeader" data-sentry-source-file="LoginBody.tsx">
      重置密码
    </h2>;
}
function ResetBody() {
  const setLoginType = useLoginType(state => state.setLoginType);
  return <div data-sentry-component="ResetBody" data-sentry-source-file="LoginBody.tsx">
      <CredientialResetPwdForm data-sentry-element="CredientialResetPwdForm" data-sentry-source-file="LoginBody.tsx" />
      <div className="mt-4 flex justify-center text-sm">
        <span className="gradient-text cursor-pointer" onClick={() => setLoginType("login")}>
          返回登录
        </span>
      </div>
    </div>;
}
export default function LoginInBody() {
  const loginType = useLoginType(state => state.loginType);
  const header = loginType === "login" ? <LoginHeader /> : loginType === "register" ? <SignUpHeader /> : <ResetHeader />;
  const body = loginType === "login" ? <LoginBody /> : loginType === "register" ? <SignUpBody /> : <ResetBody />;
  return <ModalContent className="mx-auto w-full max-w-md rounded-none bg-white p-4 shadow-input md:rounded-2xl md:p-8 dark:bg-black" data-sentry-element="ModalContent" data-sentry-component="LoginInBody" data-sentry-source-file="LoginBody.tsx">
      <ModalHeader className="mb-4 flex justify-center p-0" data-sentry-element="ModalHeader" data-sentry-source-file="LoginBody.tsx">
        {header}
      </ModalHeader>

      <ModalBody className="p-0" data-sentry-element="ModalBody" data-sentry-source-file="LoginBody.tsx">
        {body}
        <div className="my-4 h-[1px] w-full bg-gradient-to-r from-transparent via-neutral-300 to-transparent dark:via-neutral-700" />
        <div className="flex gap-4">
          <Button className="relative flex h-10 w-full items-center justify-center rounded-md bg-gray-50 px-4 font-medium text-black shadow-input" type="submit" variant="ghost" data-sentry-element="Button" data-sentry-source-file="LoginBody.tsx">
            <Image alt="wechat login" width={24} height={24} src="/images/clients/wechat.svg" data-sentry-element="Image" data-sentry-source-file="LoginBody.tsx" />
            <BottomGradient data-sentry-element="BottomGradient" data-sentry-source-file="LoginBody.tsx" />
          </Button>
          <Link href={`/api/login/tiktok?current=${window.location.pathname + window.location.search}`} className={cn(buttonVariants({
          variant: "ghost"
        }), "relative flex h-10 w-full items-center justify-center space-x-2 rounded-md bg-gray-50 px-4 font-medium text-black shadow-input")} data-sentry-element="Link" data-sentry-source-file="LoginBody.tsx">
            <Image alt="wechat login" width={24} height={24} src="/images/clients/tiktok.svg" data-sentry-element="Image" data-sentry-source-file="LoginBody.tsx" />
            <BottomGradient data-sentry-element="BottomGradient" data-sentry-source-file="LoginBody.tsx" />
          </Link>
          <Button variant="ghost" className="relative flex h-10 w-full items-center justify-center space-x-2 rounded-md bg-gray-50 px-4 font-medium text-black shadow-input" type="submit" data-sentry-element="Button" data-sentry-source-file="LoginBody.tsx">
            <Image alt="wechat login" width={24} height={24} src="/images/clients/google.svg" data-sentry-element="Image" data-sentry-source-file="LoginBody.tsx" />
            <BottomGradient data-sentry-element="BottomGradient" data-sentry-source-file="LoginBody.tsx" />
          </Button>
          <Button variant="ghost" className="group/btn group relative flex h-10 w-full items-center justify-center space-x-2 rounded-md bg-gray-50 px-4 font-medium text-black shadow-input" type="submit" data-sentry-element="Button" data-sentry-source-file="LoginBody.tsx">
            <IconDeviceMobileMessage className="size-6 text-neutral-800 group-hover:text-primary dark:text-neutral-300" data-sentry-element="IconDeviceMobileMessage" data-sentry-source-file="LoginBody.tsx" />
            <BottomGradient data-sentry-element="BottomGradient" data-sentry-source-file="LoginBody.tsx" />
          </Button>
        </div>

        <div className="mx-auto text-xs text-gray-5">
          登录/注册账号，即表示你同意
          <Link className="hover:underline" href="/terms" data-sentry-element="Link" data-sentry-source-file="LoginBody.tsx">
            服务条款
          </Link>
          ，并确认已阅读
          <Link className="hover:underline" href="/privacy" data-sentry-element="Link" data-sentry-source-file="LoginBody.tsx">
            隐私政策
          </Link>
          。
        </div>
      </ModalBody>
    </ModalContent>;
}
const BottomGradient = () => {
  return <>
      <span className="absolute inset-x-0 -bottom-px block h-px w-full bg-gradient-to-r from-transparent via-cyan-500 to-transparent opacity-0 transition duration-500 group-hover/btn:opacity-100" />
      <span className="absolute inset-x-10 -bottom-px mx-auto block h-px w-1/2 bg-gradient-to-r from-transparent via-indigo-500 to-transparent opacity-0 blur-sm transition duration-500 group-hover/btn:opacity-100" />
    </>;
};